module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row empty-state js-empty-state"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "svg-content",
    domProps: {
      "innerHTML": _vm._s(_vm.pipelinesEmptyStateSVG)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 text-center"
  }, [_c('div', {
    staticClass: "text-content"
  }, [_c('h4', [_vm._v("Build with confidence")]), _vm._v(" "), _c('p', [_vm._v("\n        Continous Integration can help catch bugs by running your tests automatically,\n        while Continuous Deployment can help you deliver code to your product environment.\n      ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-info",
    attrs: {
      "href": _vm.helpPagePath
    }
  }, [_vm._v("\n        Get started with Pipelines\n      ")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /var/cache/omnibus/src/gitlab-rails/~/vue-loader/lib/template-compiler?{"id":"data-v-492e488a"}!/var/cache/omnibus/src/gitlab-rails/~/vue-loader/lib/selector.js?type=template&index=0!./pipelines/components/empty_state.vue
// module id = ../../../node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-492e488a"}!../../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./pipelines/components/empty_state.vue
// module chunks = commit_pipelines pipelines